import { useEffect, useState } from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { api } from "@/lib/apiClient";
import { BookOpen, FileText, Rocket, Download, Eye, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

const RES_ICONS = [BookOpen, FileText, Rocket];

export default function Panduan() {
  const [resources, setResources] = useState(null);

  useEffect(() => {
    api.get("/resources").then(({ data }) => setResources(data || [])).catch(() => setResources([]));
  }, []);

  return (
    <DashboardLayout>
      <div className="animate-fade-up">
        <h1 className="font-heading text-2xl sm:text-3xl font-extrabold tracking-tight text-ink" data-testid="panduan-header">
          Panduan IDEbisnis AI
        </h1>
        <p className="mt-3 max-w-2xl text-base text-ink-soft leading-relaxed">
          Kumpulan sumber daya untuk membantu Anda memilih dan menguji bisnis dengan lebih terstruktur.
        </p>
      </div>

      {resources === null ? (
        <div className="mt-10 flex justify-center py-10"><Loader2 className="h-7 w-7 animate-spin text-brand-accent" /></div>
      ) : (
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="panduan-cards">
          {resources.map((r, i) => {
            const Icon = RES_ICONS[i] || BookOpen;
            return (
              <div key={r.key} data-testid={`panduan-card-${r.key}`} className="flex flex-col rounded-2xl border border-borderc bg-white p-6">
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand/10 text-brand"><Icon className="h-6 w-6" /></div>
                <h3 className="mt-5 font-heading text-lg font-semibold text-ink">{r.title}</h3>
                <p className="mt-2 flex-1 text-sm text-ink-soft leading-relaxed">{r.description}</p>
                {r.linked ? (
                  <div className="mt-5 flex gap-2">
                    <Button variant="outline" className="flex-1 gap-2 border-borderc" onClick={() => window.open(r.view_url, "_blank")} data-testid={`panduan-view-${r.key}`}><Eye className="h-4 w-4" /> Lihat</Button>
                    <Button className="flex-1 gap-2 bg-brand hover:bg-brand-hover" onClick={() => window.open(r.download_url || r.view_url, "_blank")} data-testid={`panduan-download-${r.key}`}><Download className="h-4 w-4" /> Unduh</Button>
                  </div>
                ) : (
                  <span className="mt-5 inline-flex w-fit items-center gap-1.5 rounded-full bg-slate-100 px-3 py-1.5 text-xs font-medium text-ink-muted" data-testid={`panduan-status-${r.key}`}>Belum ditautkan</span>
                )}
              </div>
            );
          })}
        </div>
      )}
    </DashboardLayout>
  );
}
